import type { PageContext } from '@zto/zpage-runtime'

/**
 * 门店管理 · 门店库存（PRD §7：只读、实时查询；接口 URL 待对接）
 */
export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/oms/AdminOmsShopStockQueryController/page'
      }
    },
    search: {
      labelWidth: 100,
      afterSearch: ({ app, searchParams }: PageContext) => {
        app.emits('$page_store_stock_search', searchParams)
      },
      items: [
        {
          type: 'fuzzy-select',
          prop: 'inShopCode',
          // labelProp: 'shopName',
          label: '门店',
          optionValueProp: 'shopCode',
          optionLabelProp: 'shopName',
          triggerFocus: true,
          remote: true,
          keywordProp: 'shopName',
          api: '/cabinet/admin/base/AdminBaseShopQueryController/queryList',
          span: 6
        },
        { type: 'input', prop: 'productCode', label: '商品编码', span: 6 },
        { type: 'input', prop: 'productName', label: '商品名称', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [
        {
          cmpt: 'CCabinetStockUpdateTime',
          listeners: {
            storeStockSearchOn: '$page_store_stock_search'
          }
        }
      ]
    },
    table: {
      noOperation: true,
      columns: [
        { label: '门店编号', prop: 'inShopCode', minWidth: 140 },
        { label: '门店名称', prop: 'inShopName', minWidth: 160 },
        { label: '商品编码', prop: 'productCode', minWidth: 140 },
        { label: '商品名称', prop: 'productName', minWidth: 160 },
        { label: '在库件数', prop: 'waitOutboundShipmentCount', minWidth: 110 }
      ]
    }
  }
}
